import { gql } from "@apollo/client";

export const GENERATE_REVENUE_OVERVIEW_REPORT = gql`
  query generateRevenueOverviewReport($duration: Int!) {
    generateRevenueOverviewReport(duration: $duration) {
      key
      message
    }
  }
`;